// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import { Menu, Submenu, MenuItem, Table, TableColumn, Button, FormItem, Form } from 'element-ui'
import 'element-ui/lib/theme-default/index.css'
// import 'element-ui/lib/theme-default/menu.css'
// import 'element-ui/lib/theme-default/menu-item.css'
// import 'element-ui/lib/theme-default/submenu.css'
import iView from 'iview'
import VueI18n from 'vue-i18n'
import 'iview/dist/styles/iview.css'
import App from './App'
import router from './router'
import store from './store'
import Api from '@/api'
import user from '@/api/user'
import account from '@/api/account'
// import { Api1 } from '@/api'
import cn from '@/lang/zh-cn'
import US from '@/lang/en-US'
import TW from '@/lang/zh-tw'
import JP from '@/lang/ja-JP'
import VN from '@/lang/vi-VN'
import TH from '@/lang/th-TH'
import VueQriously from 'vue-qriously'
import ElementLocale from 'element-ui/lib/locale'

Vue.config.productionTip = false

Vue.use(VueI18n)
Vue.use(Menu)
Vue.use(Submenu)
Vue.use(MenuItem)
Vue.use(FormItem)
Vue.use(Form)
Vue.use(Table)
Vue.use(TableColumn)
Vue.use(Button)
Vue.use(VueQriously)
Vue.use(Api)
Vue.use(iView, {
  i18n: (key, value) => i18n.t(key, value)
})
Vue.locale = () => {}

ElementLocale.i18n((key, value) => i18n.t(key, value))

const i18n = new VueI18n({
  locale: 'en-US',
  messages: {
    'zh-cn': cn,
    'en-US': US,
    'zh-tw': TW,
    'ja-JP': JP,
    'vi-VN': VN,
    'th-TH': TH
  }
})

router.beforeEach((to, from, next) => {
  iView.LoadingBar.start()
  next()
})

router.afterEach((to, from, next) => {
  if (localStorage.language) {
    i18n.locale = localStorage.language
  } else {
    user.fetchUserInfo().then(res => {
      account.get(res.user.id).then(res => {
        i18n.locale = res.account.language
      })
    })
  }
  iView.LoadingBar.finish()
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  i18n,
  router,
  store,
  template: '<App/>',
  components: { App }
})



// WEBPACK FOOTER //
// ./src/main.js